import { IPromise } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { Subject } from "rxjs";
import { INavItem } from "@webapp/navigation/models/nav-items-list.models";
import { IUXCustomizationItemResponse, UXCustomizationType } from "@gtmhub/uxcustomization/models";
import { IFavoriteItemsGroupedReqParams, IFavoritesChange, IFavoritesItemsGroupedResponse, IFavoritesPayload } from "./models";
import { FavoritesPayloadBuilder } from "./favorites-payload.builder";

export class FavoritesService {
  public static $inject = ["$http", "EnvironmentService", "FavoritesPayloadBuilder"];
  public favoritesChangeSubject: Subject<IFavoritesChange>;

  constructor(private $http: ng.IHttpService, private env: EnvironmentService, public favoritesPayloadBuilder: FavoritesPayloadBuilder) {
    this.favoritesChangeSubject = new Subject();
  }

  public getFavoriteItems(params: IFavoriteItemsGroupedReqParams): IPromise<IFavoritesItemsGroupedResponse> {
    const url = this.env.getUXCustomizationEndpoint(`/favorite`);

    return this.$http.get<IFavoritesItemsGroupedResponse>(url, { params }).then((response) => response.data);
  }

  public markItemAsFavorite<T extends UXCustomizationType>(payload: IFavoritesPayload, item?: INavItem): IPromise<IUXCustomizationItemResponse<T>> {
    const url = this.env.getUXCustomizationEndpoint(`/favorite`);

    return this.$http.post<IUXCustomizationItemResponse<T>>(url, payload).then((response) => {
      this.favoritesChangeSubject.next({
        type: payload.type,
        item: { ...item, id: response.data.itemId, favoriteId: response.data.id },
        eventType: "CREATE",
      });
      return response.data;
    });
  }

  public unmarkItemAsFavorite<T extends UXCustomizationType>(favoriteId: string, item: INavItem): IPromise<IUXCustomizationItemResponse<T>> {
    const url = this.env.getUXCustomizationEndpoint(`/favorite`);

    return this.$http.delete<IUXCustomizationItemResponse<T>>(`${url}/${favoriteId}`).then((response) => {
      this.favoritesChangeSubject.next({
        type: item.uxcType,
        item,
        eventType: "DELETE",
      });
      return response.data;
    });
  }

  public reorderFavoriteItem<T extends UXCustomizationType>(favoriteId: string, newOrder: number): IPromise<IUXCustomizationItemResponse<T>> {
    const url = this.env.getUXCustomizationEndpoint(`/favorite`);

    return this.$http.patch<IUXCustomizationItemResponse<T>>(`${url}/${favoriteId}/reorder`, { order: newOrder }).then((response) => {
      return response.data;
    });
  }

  public update(updatedNavItem: INavItem, type: UXCustomizationType): void {
    this.favoritesChangeSubject.next({
      type,
      item: updatedNavItem,
      eventType: "UPDATE",
    });
  }
}
